import { useQuery } from '@tanstack/vue-query';
import { useGmApi } from '@/composables/useGmApi';
import type { UseQueryOptions } from '@/types/query';
import type { ApiMe } from '@/types/users';
import { getMeQueryKey } from '@/utils/queries/users';

type UseMeQueryOptions<T> = UseQueryOptions<ApiMe, T, null>;

export function getMeQueryOptions() {
  const { getMe } = useGmApi();

  return {
    queryKey: getMeQueryKey(),
    queryFn: getMe,
    staleTime: Infinity, // Never stale — a later read must reuse this entry
    retry: false,
  };
}

export function useMeQuery<T = ApiMe>(
  queryOptions: UseMeQueryOptions<T> = {},
) {
  const { queryKey, queryFn, staleTime, retry } = getMeQueryOptions();

  const query = useQuery({
    staleTime,
    retry,
    ...queryOptions,
    queryKey,
    queryFn,
    meta: {
      errorToast: {
        disabled: true, // Disable toast - errors are handled manually by logging out
      },
    },
    select: (me) => {
      return {
        ...me,
        teams: [...me.teams].sort((a, b) => a.name.localeCompare(b.name)),
      };
    },
  });

  return query;
}
